import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const notificationCenterProps = {
  visible: Boolean,
};

export type NotificationCenterProps = {
  visible: boolean;
};

export const Container = styled('div', notificationCenterProps)`
  ${({ visible }: NotificationCenterProps) => css`
    background-color: ${theme.colors.grayBg};
    height: 100%;
    right: 0;
    max-width: 652px;
    overflow-y: auto;
    padding: 40px 48px 0px 48px;
    width: 100%;
    position: absolute;
    transition: right .75s;
    z-index: ${theme.layers.modal};

    ${!visible && 'right: -100%'};

    &:after {
      content: "";
      display: block;
      height: 40px;
      width: 100%;
    }

    > header {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    > p {
      font-size: ${theme.font.sizes.p1};
      line-height: ${theme.font.lineHeights.p1};
    }

    > section > div > div {
      margin-top: ${theme.spacings.xsmall};
    }

    .notification-not-viewed {
      margin-top: 45px;

      > p {
        color: ${theme.colors.supportSuccess};
      }
    }

    .notification-viewed {
      margin-top: 45px;

      > p {
        color: ${theme.colors.gray6};
      }
    }
  `}
`;

export const Wrapper = styled('div', notificationCenterProps)`
  ${({ visible }: NotificationCenterProps) => css`
    background-color: rgba(0, 0, 0, 0.45);
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    left: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 68px;
    z-index: ${theme.layers.overlay};

    ${!visible ? 'opacity: 0' : 'opacity: 1'};
    ${!visible ? 'height: 0' : 'height: calc(100% - 68px)'};

    ${!visible ? 'transition: height 0s linear .5s, opacity .25s linear .25s' : 'transition: height 0s linear, opacity .25s linear'};

    & span.spinner {
      margin: 40px auto;
      display: block;
      border-radius: 100%;
      width: 2.5rem;
      height: 2.5rem;
      border: 3px solid #dcdcdc;
      border-left-color: ${theme.colors.gray5};
      animation: loading 1s linear infinite;

      @keyframes loading {
        100% {
          transform: rotate(360deg);
        }
      }
    }
  `}
`;
